import { Injectable } from '@angular/core';
import { AuthService, DrivelogUser } from './auth.service';
import Keycloak from 'keycloak-js';
import { environment } from '../../../environments/environment';
import { runtimeUrl } from '../runtime-config';

@Injectable({ providedIn: 'root' })
export class KeycloakAuthService extends AuthService {
  private keycloak = new Keycloak({
    url: runtimeUrl('KEYCLOAK_URL', environment.keycloak.url),
    realm: environment.keycloak.realm,
    clientId: environment.keycloak.clientId,
  });

  async init(): Promise<boolean> {
    return this.keycloak.init({ onLoad: 'login-required', pkceMethod: 'S256', checkLoginIframe: false });
  }

  isAuthenticated(): boolean { return !!this.keycloak.authenticated; }
  getToken(): string | null { return this.keycloak.token ?? null; }

  getUser(): DrivelogUser | null {
    const p = this.keycloak.tokenParsed;
    if (!p) return null;
    return {
      id: p['dbUserId'] ?? p['sub'] ?? '',
      name: p['name'] ?? p['preferred_username'] ?? '',
      email: p['email'] ?? '',
      roles: this.keycloak.realmAccess?.roles ?? [],
    };
  }

  login(): void { this.keycloak.login(); }
  logout(): void { this.keycloak.logout(); }

  async refreshToken(): Promise<boolean> {
    try {
      // Negative minValidity forces a refresh regardless of the token's current expiry.
      await this.keycloak.updateToken(-1);
      return true;
    } catch {
      return false;
    }
  }
}
